module.exports = __webpack_public_path__ + "img/jordy_grimm.9db40a92.png";